import { DroneStatus } from './DroneFeedManager';

export interface NormalizedFrame {
  frameData: string; // base64 string
  metadata: {
    gps?: { lat: number; lng: number } | null;
    altitudeMeters?: number | null;
    timestamp: Date;
    source: 'DRONE' | 'TEST' | 'PHONE';
  };
}

export class DroneFeedAdapter {
  /**
   * Normalizes raw drone frames into the format expected by AR damage detection engine
   */
  static normalizeFrame(rawFrame: string, status: DroneStatus): NormalizedFrame {
    const source = status.connectionType === 'TEST' ? 'TEST' : 'DRONE';
    
    return {
      frameData: rawFrame,
      metadata: {
        gps: status.gps || null,
        altitudeMeters: status.altitudeMeters || null,
        timestamp: new Date(),
        source
      }
    };
  }

  /**
   * Normalizes phone camera frames for consistency
   */
  static normalizePhoneFrame(frameData: string): NormalizedFrame {
    return {
      frameData,
      metadata: {
        gps: null,
        altitudeMeters: null,
        timestamp: new Date(),
        source: 'PHONE'
      }
    };
  }

  /**
   * Converts a base64 image to a normalized frame
   */
  static base64ToFrame(base64Image: string, source: 'DRONE' | 'TEST' | 'PHONE' = 'PHONE'): NormalizedFrame {
    // Remove data URL prefix if present
    const base64Data = base64Image.replace(/^data:image\/\w+;base64,/, '');
    
    return {
      frameData: base64Data,
      metadata: {
        gps: null,
        altitudeMeters: null,
        timestamp: new Date(),
        source
      }
    };
  }

  /**
   * Returns the base64 data from a normalized frame
   */
  static frameToBase64(frame: NormalizedFrame): string {
    return frame.frameData;
  }
}
